import { useEffect, useState } from "react";

const RedCardsTab = ({ tournament, selectedSubcategory }) => {
  const [redCards, setRedCards] = useState([]);
  const [loading, setLoading] = useState(true);

  const defaultPlayerImage =
    "https://cdn-icons-png.flaticon.com/512/149/149071.png"; // 👤 Imagen genérica

  useEffect(() => {
    if (!tournament?.id) return; // 🚨 Evita fetch si no hay id

    const fetchRedCards = async () => {
      try {
        const url = selectedSubcategory
          ? `https://server-postgre.vercel.app/api/tournaments/${tournament.id}/red-cards?subcategoryId=${selectedSubcategory.id}`
          : `https://server-postgre.vercel.app/api/tournaments/${tournament.id}/red-cards`;

        const res = await fetch(url);
        const data = await res.json();
        setRedCards(data);
      } catch (error) {
        console.error("Error al cargar tarjetas rojas", error);
      } finally {
        setLoading(false);
      }
    };

    fetchRedCards();
  }, [tournament, selectedSubcategory]);

  if (loading) return <p>Cargando...</p>;

  return (
    <div>
      <h3 className="font-semibold mb-3 text-red-700 flex items-center">
        🟥 Tarjetas Rojas
      </h3>
      {redCards.length > 0 ? (
        <div className="space-y-2">
          {redCards.map((player, index) => (
            <div
              key={player.player_id}
              className="flex items-center p-3 bg-white rounded-lg border border-red-200 shadow-sm hover:shadow-md transition"
            >
              {/* Posición */}
              <span className="w-8 text-center font-bold text-gray-700">
                {index + 1}°
              </span>

              {/* Jugador */}
              <div className="flex items-center flex-1 ml-4">
                <img
                  src={player.profile_picture_url || defaultPlayerImage}
                  alt={`${player.first_name} ${player.last_name}`}
                  className="w-10 h-10 rounded-full object-cover border-2 border-white shadow"
                />

                <div className="ml-3 flex-1">
                  <h4 className="font-medium text-gray-900">
                    {player.first_name} {player.last_name}
                  </h4>
                  <div className="flex items-center mt-1">
                    {player.team_picture_url && (
                      <img
                        src={player.team_picture_url}
                        alt={player.team_name}
                        className="w-5 h-5 mr-2 object-contain"
                      />
                    )}
                    <span className="text-xs text-gray-600">
                      {player.team_name}
                    </span>
                  </div>
                </div>
              </div>

              {/* Tarjetas rojas */}
              <div className="ml-auto bg-red-100 px-3 py-1 rounded-full border border-red-400 flex items-center">
                <span className="font-bold text-red-800">
                  {player.red_cards}
                </span>
                <span className="text-xs text-red-700 ml-1">rojas</span>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-gray-500">No hay datos de tarjetas rojas</p>
      )}
    </div>
  );
};

export default RedCardsTab;
